export const computeQuantiles = numbers => {
	const sortedNumbers = numbers.filter(Number.isFinite).sort((a, b) => a - b);

	if (!sortedNumbers.length) {
		return { Q1: NaN, Q2: NaN, Q3: NaN };
	}

	const quantileAt = percentile => {
		const index = (sortedNumbers.length - 1) * percentile;
		const lowerIndex = Math.floor(index);
		const upperIndex = Math.ceil(index);

		if (lowerIndex === upperIndex) {
			return sortedNumbers[lowerIndex];
		}

		const weight = index - lowerIndex;

		return sortedNumbers[lowerIndex] * (1 - weight) + sortedNumbers[upperIndex] * weight;
	};

	return {
		Q1: quantileAt(0.25),
		Q2: quantileAt(0.5),
		Q3: quantileAt(0.75),
	};
};
